import React, { useEffect, useState, useRef } from "react";
import { API_Link, validateHeader } from "../../commons/Constants";
import icon1 from "./../../assets/img/icon/icon1.svg";
import icon2 from "./../../assets/img/icon/icon2.svg";
import icon3 from "./../../assets/img/icon/icon3.svg";
import icon4 from "./../../assets/img/icon/icon4.svg";
import icon5 from "./../../assets/img/icon/icon5.svg";
import icon6 from "./../../assets/img/icon/icon6.svg";
import icon7 from "./../../assets/img/icon/icon7.svg";
import icon8 from "./../../assets/img/icon/icon8.svg";
import axios from "axios";
import DashboardCard from "../childComponents/DashboardCard.js";

function Reviewcard() {
  const MD5hash = validateHeader();
  const [hta, setHta] = useState({});
  const [TR, setTR] = useState({});
  const [IB, setIB] = useState({});
  const [EE, setEE] = useState({});
  const [TB, setTB] = useState({});
  const [TS, setTS] = useState({});
  const [CPG, setCPG] = useState({});
  const [Other, setOther] = useState({});
  const [loader, setLoader] = useState(true);
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    {
      title: hta.description,
      figNumber: hta.completed_reviews,
      figNumber_progress: hta.inprogress_reviews,
      src: icon1,
    },
    {
      title: TR.description,
      figNumber: TR.completed_reviews,
      figNumber_progress: TR.inprogress_reviews,
      src: icon2,
    },
    {
      title: IB.description,
      figNumber: IB.completed_reviews,
      figNumber_progress: IB.inprogress_reviews,
      src: icon3,
    },
    {
      title: EE.description,
      figNumber: EE.completed_reviews,
      figNumber_progress: EE.inprogress_reviews,
      src: icon4,
    },
    {
      title: TB.description,
      figNumber: TB.completed_reviews,
      figNumber_progress: TB.inprogress_reviews,
      src: icon5,
    },
    {
      title: TS.description,
      figNumber: TS.completed_reviews,
      figNumber_progress: TS.inprogress_reviews,
      src: icon6,
    },
    {
      title: CPG.description,
      figNumber: CPG.completed_reviews,
      figNumber_progress: CPG.inprogress_reviews,
      src: icon7,
    },
    {
      title: Other.description,
      figNumber: Other.completed_reviews,
      figNumber_progress: Other.inprogress_reviews,
      src: icon8,
    },
  ];

  const itemsPerGroup = Math.ceil(cards.length / 3);
  const getReviewTypesCount = () => {
    setIsLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewTypesCount`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        setHta(APIresponse[0]);
        setTR(APIresponse[1]);
        setIB(APIresponse[2]);
        setEE(APIresponse[3]);
        setTB(APIresponse[4]);
        setTS(APIresponse[5]);
        setCPG(APIresponse[6]);
        setOther(APIresponse[7]);
        setIsLoading(false);
        setLoader(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getReviewTypesCount();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (containerRef.current) {
        const container = containerRef.current;

        if (container.scrollLeft > 1065) {
          container.scrollTo({
            left: 0,
            behavior: "smooth",
          });
          setActiveIndex(0);
        } else {
          container.scrollBy({
            left: 600,
            behavior: "smooth",
          });
          setActiveIndex((prevIndex) => (prevIndex + 1) % 3);
        }
      }
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    if (containerRef.current) {
      const container = containerRef.current;
      const scrollAmount = 3;
      container.scrollTo({
        left: 0,
        behavior: "smooth",
      });
      setActiveIndex(index);
    }
  };

  return (
    <div className="dashboard--page">
      <div className="row">
        <div className="col-lg-12">
          <div className="dashboard--page">
            <div className="slider-container">
              <div className="cards-container" ref={containerRef}>
                {cards.map((card, index) => (
                  <DashboardCard
                    key={index}
                    title={card.title}
                    figNumber={card.figNumber}
                    figNumber_progress={card.figNumber_progress}
                    src={card.src}
                  />
                ))}
              </div>
            </div>
            <div className="slider-dots">
              {[...Array(3)].map((_, index) => (
                <span
                  key={index}
                  className={`dot1 ${activeIndex === index ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviewcard;
